import { render, staticRenderFns } from "./supervisory.vue?vue&type=template&id=157f0826&scoped=true&"
import script from "./supervisory.vue?vue&type=script&lang=js&"
export * from "./supervisory.vue?vue&type=script&lang=js&"
import style0 from "./supervisory.vue?vue&type=style&index=0&lang=css&"
import style1 from "./supervisory.vue?vue&type=style&index=1&id=157f0826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157f0826",
  null
  
)

export default component.exports